<template>
  <NavigationDesktopNav
    v-if="!isDeliveryMan"
    :nav="navObject"
  />
  <HeaderMobile
    :nav="navObject"
    :new-notifications="newNotifications"
    @notification="notification"
  />
</template>

<script lang="ts" setup>
import { RouteNames } from '~/app/routes/routeNames';
import type { NavItem } from './NavItem.type';

const store = useFloristInfoStore();
const { floristInfo: floristInfo } = storeToRefs(store);
const isDeliveryMan = ref(store.isDeliveryMan);

const navObject = ref<NavItem[]>([]);

type Props = {
  internalUser: boolean;
  newNotifications: boolean;
};

const props = defineProps<Props>();
const emits = defineEmits(['notification']);

const notification = (value: boolean) => {
  return emits('notification', value);
};

const NAV_ITEMS_MAP = {
  home: { path: RouteNames.Home, icon: 'IconHome', label: 'home' },
  orders: { path: RouteNames.OrderList, icon: 'IconFlowers', label: 'orders' },
  history: { path: RouteNames.History, icon: 'IconClock', label: 'history' },
  transmissions: { path: RouteNames.OrderTransmissionList, icon: 'IconShop', label: 'transmissions' },
  myPage: { path: RouteNames.MyPage, icon: 'IconProfile', label: 'page' },
  contact: { path: RouteNames.Contact, icon: 'IconMailHeart', label: 'contact' },
  internalSelect: { path: RouteNames.InternalUserSelect, icon: 'IconBonus', label: 'internalUser' },
  xlFlorist: { path: RouteNames.XLFlorist, icon: 'IconMegaphone', label: 'xlFlorist' }, // TODO-XL select proper icon
};

const setNavMenuItems = () => {
  if (!floristInfo.value.floristId) {
    navObject.value = [NAV_ITEMS_MAP.internalSelect];
    return;
  }

  const isFrOrIt = isFrenchFlorist || isItalianFlorist;
  const { blockedInExecution, blockedInTransmission } = floristInfo.value?.floristActivity ?? {};

  let items;
  if (isFrOrIt && blockedInExecution) {
    items = [NAV_ITEMS_MAP.home, NAV_ITEMS_MAP.transmissions, NAV_ITEMS_MAP.myPage];
  } else if (isFrOrIt && blockedInTransmission) {
    items = [NAV_ITEMS_MAP.home, NAV_ITEMS_MAP.orders, NAV_ITEMS_MAP.history, NAV_ITEMS_MAP.myPage];
  } else if (isFrOrIt) {
    items = [
      NAV_ITEMS_MAP.home,
      NAV_ITEMS_MAP.orders,
      NAV_ITEMS_MAP.history,
      NAV_ITEMS_MAP.transmissions,
      NAV_ITEMS_MAP.myPage,
    ];
  } else if (blockedInExecution) {
    items = [
      NAV_ITEMS_MAP.home,
      NAV_ITEMS_MAP.transmissions,
      NAV_ITEMS_MAP.history,
      NAV_ITEMS_MAP.myPage,
      NAV_ITEMS_MAP.contact,
    ];
  } else if (isSpanishFlorist) {
    items = [
      NAV_ITEMS_MAP.home,
      NAV_ITEMS_MAP.orders,
      NAV_ITEMS_MAP.transmissions,
      NAV_ITEMS_MAP.history,
      NAV_ITEMS_MAP.myPage,
    ];
  } else {
    items = [
      NAV_ITEMS_MAP.home,
      NAV_ITEMS_MAP.orders,
      NAV_ITEMS_MAP.transmissions,
      NAV_ITEMS_MAP.history,
      NAV_ITEMS_MAP.myPage,
      NAV_ITEMS_MAP.contact,
    ];
  }

  if (props.internalUser) {
    const leadingItems = [...(props.internalUser ? [NAV_ITEMS_MAP.internalSelect] : [])];
    items = [...leadingItems, ...items];
  }

  navObject.value = items;
};

setNavMenuItems();
</script>
